import type { CondensateDewPointPressureCalculator } from "../../d";
import { withoutAbsentGasComponents } from "@/libs/calculations/gasPhase/gasTable";

export const dewPointPressurePSIACalculator: CondensateDewPointPressureCalculator =
  params => {
    const {
      pressurePSIA,
      gasSpecificGravity,
      gasProperties,
      isPengRobinson,
      hasGasCompositeValues,
      dewPointPressurePSIAOverride,
      x
    } = params;

    let dewPointPressure = 0;
    if (dewPointPressurePSIAOverride && dewPointPressurePSIAOverride > 0) {
      dewPointPressure = dewPointPressurePSIAOverride;
    } else if (isPengRobinson || hasGasCompositeValues) {
      // PVT!K70 = 1/SUM(AP78:AP91)
      const sumDewPoint = withoutAbsentGasComponents(gasProperties).reduce(
        (sum, component) => sum + (component.dewPoint || 0),
        0
      );
      dewPointPressure = sumDewPoint > 0 ? 1 / sumDewPoint : 0;
    } else {
      // PVT!BJ107 inverts BJ99 at the same pressure
      const rsoAtPressure =
        ((pressurePSIA / 112.727 + 12.34) *
          gasSpecificGravity ** 0.8439 *
          10 ** x) **
        1.73184;
      const petroskyFarshad =
        (112.727 * rsoAtPressure ** 0.577421) /
          (gasSpecificGravity ** 0.8439 * 10 ** x) -
        1391.051;
      dewPointPressure = Number.isFinite(petroskyFarshad) ? petroskyFarshad : 0;
    }

    return {
      dewPointPressurePSIA: Math.max(dewPointPressure, 0)
    };
  };
